import script from "./membership-plans.vue?vue&type=script&setup=true&lang=js"
export * from "./membership-plans.vue?vue&type=script&setup=true&lang=js"

import "./membership-plans.vue?vue&type=style&index=0&id=4da846a4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4da846a4"]])

export default __exports__